import React from "react";
import ChartZoomMenu, { ChartZoomMenuParam } from "./ChartZoomMenu";
import ChartEditMenu, { ChartEditMenuParam } from "./ChartEditMenu";

export interface ChartDialogMenuParam
  extends ChartZoomMenuParam,
    ChartEditMenuParam {
  /**
   * 編集状態の場合true,それ以外の場合falseを設定します
   */
  edit: boolean;
  /**
   * ChartEditMenuを有効にする場合はtrue,それ以外はfalseを設定します
   */
  editMenu: boolean;
}

/**
 * チャートダイアログメニューを表示します
 * @param {ChartDialogMenuParam} props - ダイアログメニューパラメータ
 * @returns チャートダイアログメニュー
 */
export default function ChartDialogMenu(props: ChartDialogMenuParam) {
  const {
    edit,
    editMenu,
    onXZoomUp,
    onXZoomOut,
    onYZoomUp,
    onYZoomOut,
    id,
    x,
    range,
    onRegist,
  } = props;
  const chartEditMenu =
    edit && editMenu ? (
      <ChartEditMenu id={id} x={x} range={range} onRegist={onRegist} />
    ) : (
      ""
    );
  return (
    <div>
      <ChartZoomMenu
        onXZoomUp={onXZoomUp}
        onXZoomOut={onXZoomOut}
        onYZoomUp={onYZoomUp}
        onYZoomOut={onYZoomOut}
      />
      <div style={{ height: "25px" }}></div>
      {chartEditMenu}
    </div>
  );
}
